import { j as s } from "./atoms-v218.js";
import { Button as l } from "./atoms-v21220.js";
const m = ({
  ariaLabel: t,
  brand: e,
  className: o,
  colorTheme: i,
  display: r = "inline",
  size: a,
  variant: n
}) => /* @__PURE__ */ s.jsx(
  l,
  {
    disabled: !0,
    $brand: e,
    $colorTheme: i,
    $display: r,
    $isSkeleton: !0,
    $size: a,
    $variant: n,
    "aria-hidden": "true",
    "aria-label": t,
    className: o,
    "data-testid": "button-skeleton"
  }
);
export {
  m as ButtonSkeleton
};
